// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZKD0p","actions":"styles_actions__3kkJV","error":"styles_error__2a0Pi","message":"styles_message__2SUPP"};